import React from 'react'
import { getContentfulImageURL } from '../../../../lib/helpers'
import CategoryTag from '../../General/CategoryTag'


const ArticleV2Landing = ({data}) => {

    const overlayColor1 = data?.gradientColorsLandingOverlay ? data?.gradientColorsLandingOverlay[0] : 'transparent'
    const overlayColor2 = data?.gradientColorsLandingOverlay ? data?.gradientColorsLandingOverlay[1] : 'transparent';

    return (
        <div className="landing">
            <div className="landing-image">
                {data?.gradientColorsLandingOverlay ? <div className='gradient-overlay'></div> : null }
                <img className='mobile' src={getContentfulImageURL(data?.posterImage?.file?.url, 1000, 90)} alt="" />
                <img className="desktop" src={`${data?.posterImage?.file?.url}?w=1800&h=1600&fit=fill&f=top&q=80&fm=webp`} alt="" />
            </div>

            <div className="landing-overlay">
                {data?.articleLength ? <h5 className='article-length'>{data?.articleLength} minute read</h5> : null}


                <h1 className='article-title elizeth'>{data?.title}</h1>
                <div className="tags">
                    <CategoryTag>
                        {data?.category}
                    </CategoryTag>
                    <CategoryTag>
                        Season 2
                    </CategoryTag>
                </div>
            </div>

            <style jsx>{`
                .landing {
                    position: relative;
                }   

                .landing-image {
                    line-height: 0;
                    height: 0;
                    padding-bottom: 56.25%;
                    position: relative;
                    overflow: hidden;
                }

                .gradient-overlay {
                    position: absolute;
                    z-index: 1;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: 
                        linear-gradient(to right, ${overlayColor1}, ${overlayColor2});
                        
                        
                }




                .landing-image .desktop {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .landing-overlay {
                    position: absolute;
                    z-index: 2;
                    bottom: 60px;
                    left: 40px;
                    color: white;
                }

                .article-length {
                    font-size: 20px;
                    font-weight: 400;
                }

                .tags {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    width: 200px;
                    grid-gap: 10px;
                }

                .article-title { 
                    font-size: 70px;
                    margin: 10px 0 40px;
                    max-width: 750px;
                    text-shadow: 0 0 5px rgba(0,0,0,.13);

                    font-family: 'Elizeth';
                    font-style: italic;
                    font-weight: 900;
                }

                img {
                    width: 100%;
                }

                .mobile {
                    display: none;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    .desktop {
                        display: none;
                    }

                    .mobile {
                        display: inline;
                    }
                    .article-title {
                        font-size: 40px;
                    }

                    .landing-image {
                        padding-bottom: 125%;
                    }

                    .landing-overlay {
                        left: 20px;
                        bottom: 20px;
                    }

                    .article-title {
                        width: 100%;
                    }
                }
            `}</style>
        </div>
    )
}

export default ArticleV2Landing